export default () => {
  $('#qa dt').on('click',function(){
    console.log('clik')
    var index = $('#qa dt').index(this),
    dt = $(this),
    dd = dt.next('dd'),
    top = Math.floor(index / 4) * 240 + 240;
    dd.css({
      'top': top+'px'
    });

    if ($('#btn_menu').is(':visible')){
      if (dd.is(':visible')){
        dt.removeClass("is-open");
      }else{
        dt.addClass("is-open");

      };
    }
    dd.fadeToggle('fast');;
  });
  $('#qa dt').hover(
    function(){},
    function(){
      var index = $('#qa dt').index(this),
    dt = $(this),
    dd = dt.next('dd');
    dd.fadeOut('fast');
    }
  );
};



// WEBPACK FOOTER //
// ./src/assets/js/page/qa.js